export const EVNTTZ_ICON_NAMES = [
  'home',
  'journeys',
  'missions',
  'quizzes',
  'prizes',
  'shop',
  'social',
  'schedule',
  'library',
  'partners',
  'support',
  'modules',
  'backpack',
  'cellphone',
  'file',
  'folder',
  'handshake'
] as const

export type EvnttzIconName = (typeof EVNTTZ_ICON_NAMES)[number]

export type EvnttzIconTint = 'brand' | 'event'
